import { render, staticRenderFns } from "./NavigationWidget.vue?vue&type=template&id=48b2966c&scoped=true&"
import script from "./NavigationWidget.vue?vue&type=script&lang=js&"
export * from "./NavigationWidget.vue?vue&type=script&lang=js&"
import style0 from "./NavigationWidget.vue?vue&type=style&index=0&id=48b2966c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2966c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VCard,VList,VListGroup,VListItem,VListItemTitle,VNavigationDrawer})
